if (process.env.SERVER === true) {
  module.exports = function (props) {
    return props.children;
  };
} else {
  module.exports = require('react-lazyload')
}